import { commonV3URL, message } from 'src/constantsMessage';
import {
  encode64Base,
  formDataToencode64Base
} from 'src/context/constantMethod';
import axios from 'src/utils/axiosHelper';
import { SET_ALERT } from './alertAction';
import authService from 'src/services/authService';
import helperAxios from 'src/utils/helperAxios';
import track from 'src/utils/analytics';

export const GET_PLANS = '@account/get-plans';
export const GET_PLANS_ERROR = '@account/get-plans-error';
export const REGISTER = '@account/register';
export const REGISTER_ERROR = '@account/register-error';
export const REGISTER_EMPTY = '@account/register-empty';
export const SEND_VERIFICATION_MAIL = '@account/send-verification-mail';
export const SEND_VERIFICATION_MAIL_FAIL =
  '@account/send-verification-mail-fail';
export const SEND_VERIFICATION_MAIL_EMPTY =
  '@account/send-verification-mail-empty';
export const VERIFY_SUCCESS = '@account/verify-success';
export const VERIFY_ERROR = '@account/verify-error';
export const VERIFY_EMPTY = '@account/verify-empty';
export const GET_PINCODEDETAIL = '@account/get-pincode-detail';
export const GET_PINCODEDETAIL_ERROR = '@account/get-pincode-detail-error';
export const LOADER = '@account/registerloader';
export const LOGIN_FAILURE = '@account/login-failure';
export const GETOTP_SUCCESS = '@account/getotp-success';
export const GETOTP_ERROR = '@account/getotp-error';
export const GETOTP_EMPTY = '@account/getotp-empty';
export const OTPVALIDATE_SUCCESS = '@account/validateotp-success';
export const OTPVALIDATE_ERROR = '@account/validateotp-error';
export const OTPVALIDATE_EMPTY = '@account/validateotp-empty';
export const RESET_OTP_SUCCESS = '@account/resetotp-success';
export const LOADER_HIDE = '@account/loader-hide';
export const PLAN_DETAILS_BY_SHORT_NAME = '@account/plan-details-by-short-name';

export function getAllplans() {
  const url = `${commonV3URL}/plan/all`;
  const request = helperAxios(url, 'get');

  return dispatch => {
    request
      .then(response =>
        dispatch({
          type: GET_PLANS,
          payload: response.data
        })
      )
      .catch(error => {
        dispatch({
          type: GET_PLANS_ERROR,
          payload: error.response && error.response.data
        });
        dispatch({
          type: SET_ALERT,
          payload: error.response && error.response.data,
          payload1: 'error',
          redirect: '/'
        });
      });
  };
}

export function topUpPlan(values, id, attribute, gstiValues, clientId, flag) {
  const data = {
    clientId: clientId || '',
    planId: id || null,
    acceptZeroPayment: 'false',
    provider: values.provider || null,
    idToken: values.idToken || null,
    discount: (gstiValues && gstiValues.discount) || null,
    accountCount:
      (gstiValues &&
        Object.values(gstiValues).some(value => value?.length !== 0) &&
        gstiValues.numberOfBankAccounts) ||
      1,
    ...(flag
      ? flag === '2'
        ? { planType: 'gst' }
        : flag === '4'
        ? { planType: 'cic' }
        : {}
      : {})
  };
  gstiValues &&
    Object.values(gstiValues).some(value => value?.length !== 0) &&
    (data.gstInfo = {
      gstin: gstiValues.gstin,
      address: gstiValues.address,
      city: gstiValues.city,
      state: gstiValues.state,
      pincode: gstiValues.pinCode
    });
  let requestBody = formDataToencode64Base(data);
  const url = `${commonV3URL}/subscription/recharge`;
  const request = helperAxios(url, 'put', requestBody);
  return async dispatch => {
    dispatch({
      type: LOADER
    });
    request
      .then(async response => {
        if (response.data.newUser && response.data.newUser.token) {
          authService.setSession(response.data.newUser.token);
          try {
            const user = await authService.loginInWithToken();
            dispatch({
              type: '@account/login-success',
              payload: {
                user
              }
            });
          } catch (error) {
            dispatch({ type: LOGIN_FAILURE });

            throw error;
          }
        }
        dispatch({
          type: REGISTER,
          payload: response.data
        });
      })
      .catch(error => {
        dispatch({
          type: REGISTER_ERROR,
          payload: error.response && error.response.data
        });
        dispatch({
          type: SET_ALERT,
          payload: error.response && error.response.data,
          payload1: 'error',
          redirect: error.response.data.status === 1005 && '/'
        });
      });
  };
}

export function validateRegisterFrom(
  values,
  captchaText,
  captchaRequestUUID,
  id,
  setResponse,
  setError,
  dispatch,
  flag
) {
  const data = {
    name: values.fullName || null,
    email: values.email || null,
    phoneNumber: values.phoneNumber || null,
    password: values.password || null,
    companyName: values.companyName || values.company || '',
    industry: values.industry || 'Lending',
    planId: id || null,
    provider: values.provider || null,
    idToken: values.idToken || null,
    country: values.country || null,
    phoneCode: values.phoneCode || null,
    ...(captchaText && captchaRequestUUID
      ? { captchaRequestUUID, captchaText }
      : {}),
    ...(flag
      ? flag === '2'
        ? { planType: 'gst' }
        : flag === '4'
        ? { planType: 'cic' }
        : {}
      : {})
  };
  let requestBody = formDataToencode64Base(data);
  const url = `${commonV3URL}/subscription/validate`;
  const request = helperAxios(url, 'post', requestBody);
  request
    .then(async response => {
      setResponse(response);
    })
    .catch(error => {
      setError(error);
      dispatch({
        type: SET_ALERT,
        payload: error?.response && error?.response?.data,
        payload1: 'error',
        redirect: error.response.data.status === 1005 && '/'
      });
    });
}

export function register(
  values,
  id,
  attribute,
  gstiValues,
  clientId,
  plans,
  captchaText,
  captchaRequestUUID,
  flag
) {
  const data = {
    name: values.fullName || null,
    email: values.email || null,
    phoneNumber: values.phoneNumber || null,
    password: values.password || null,
    companyName: values.companyName || values.company || '',
    industry: values.industry || 'Lending',
    planId: id || null,
    provider: values.provider || null,
    idToken: values.idToken || null,
    country: values.country || null,
    phoneCode: values.phoneCode || null,
    discount: (gstiValues && gstiValues.discount) || null,
    accountCount:
      (gstiValues &&
        Object.values(gstiValues).some(value => value?.length !== 0) &&
        gstiValues.numberOfBankAccounts) ||
      1,
    ...(captchaText && captchaRequestUUID
      ? { captchaRequestUUID, captchaText }
      : values?.captchaText && localStorage.getItem('captchaRequestUUID')
      ? {
          captchaText: values?.captchaText,
          captchaRequestUUID: localStorage.getItem('captchaRequestUUID')
        }
      : {}),
    ...(flag
      ? flag === '2'
        ? { planType: 'gst' }
        : flag === '4'
        ? { planType: 'cic' }
        : {}
      : {})
  };
  clientId && (data.clientId = clientId);
  gstiValues &&
    Object.values(gstiValues).some(value => value?.length !== 0) &&
    (data.gstInfo = {
      gstin: gstiValues.gstin,
      address: gstiValues.address,
      city: gstiValues.city,
      state: gstiValues.state,
      pincode: gstiValues.pinCode
    });

  attribute &&
    attribute !== '' &&
    (data.googleAdInfo = attribute
      .slice(1)
      .split('&')
      .reduce((obj, searchStr, index) => {
        let strList = searchStr.split('=');
        if (strList[0] === 'flag') return obj;
        if (strList[0] === 'campaignid') obj.campaignId = strList[1];
        else if (strList[0] === 'adgroupid') obj.adGroupId = strList[1];
        else if (strList[0] === 'keyword') obj.keyword = strList[1];
        else if (strList[0] === 'utm_source') obj.utm_source = strList[1];
        else if (strList[0] === 'utm_campaign') obj.utm_campaign = strList[1];
        else obj[strList[0]] = strList[1];
        return obj;
      }, {}));
  let requestBody = formDataToencode64Base(data);
  const url = `${commonV3URL}/subscription`;
  const request = helperAxios(url, 'put', requestBody);
  return async dispatch => {
    dispatch({
      type: LOADER
    });
    request
      .then(async response => {
        if (plans.plans.find(e => parseInt(e.id) === parseInt(id))) {
          {
            plans.plans.find(e => parseInt(e.id) === parseInt(id)).shortName ===
            'PAYG'
              ? track.event('payg_success_registration', {
                  event_category: 'bsa_analytics'
                })
              : plans.plans.find(e => parseInt(e.id) === parseInt(id))
                  .shortName === 'PPU'
              ? track.event('ppu_success_registration', {
                  event_category: 'bsa_analytics'
                })
              : track.event('free_success_registration', {
                  event_category: 'bsa_analytics'
                });
          }
        }
        if (response.data.newUser && response.data.newUser.token) {
          authService.setSession(response.data.newUser.token);
          try {
            const user = await authService.loginInWithToken();
            dispatch({
              type: '@account/login-success',
              payload: {
                user
              }
            });
          } catch (error) {
            dispatch({ type: LOGIN_FAILURE });

            throw error;
          }
        }
        dispatch({
          type: REGISTER,
          payload: response.data
        });
      })
      .catch(error => {
        dispatch({
          type: REGISTER_ERROR,
          payload: error.response && error.response.data
        });
        dispatch({
          type: SET_ALERT,
          payload: error.response && error.response.data,
          payload1: 'error',
          redirect:
            error &&
            error.response &&
            error.response.data.status === 1005 &&
            '/'
        });
      });
  };
}

export function registerEmpty() {
  return dispatch => {
    dispatch({ type: REGISTER_EMPTY });
  };
}

export function sendVerificationEmail(email) {
  const request = axios({
    method: 'get',
    url: `${commonV3URL}/subscription/resendEmail?email=${email}`
  });
  return dispatch => {
    dispatch({
      type: LOADER
    });
    request
      .then(response => {
        dispatch({
          type: SEND_VERIFICATION_MAIL,
          payload: response.data
        });
        dispatch({
          type: SET_ALERT,
          payload: message.emailSent,
          payload1: 'success'
        });
      })
      .catch(error => {
        dispatch({
          type: SEND_VERIFICATION_MAIL_FAIL,
          payload: error.response && error.response.data
        });
        dispatch({
          type: SET_ALERT,
          payload: error.response && error.response.data,
          payload1: 'error'
        });
      });
  };
}

export function sendVerificationEmailEmpty() {
  return dispatch => {
    dispatch({ type: SEND_VERIFICATION_MAIL_EMPTY });
  };
}

export function verifyEmail(token) {
  const request = axios({
    method: 'post',
    url: `${commonV3URL}/subscription/emailVerification?verifyEmailToken=${token}`
  });
  return dispatch => {
    dispatch({
      type: LOADER,
      payload: 'Processing your verification. Please wait...'
    });
    request
      .then(response => {
        dispatch({
          type: VERIFY_SUCCESS,
          payload: response.data
        });
        setTimeout(() => {
          dispatch({
            type: SET_ALERT,
            payload: message.emailVerified,
            payload1: 'success'
          });
        });
      }, 3000)
      .catch(error => {
        dispatch({
          type: VERIFY_ERROR,
          payload: error.response && error.response.data
        });
        setTimeout(() => {
          dispatch({
            type: SET_ALERT,
            payload: error.response && error.response.data,
            payload1: 'error'
          });
        }, 3000);
      });
  };
}

export function verifyEmpty() {
  return dispatch => {
    dispatch({
      type: VERIFY_EMPTY
    });
  };
}

export function getPinCodeDetail(pinCode) {
  const request = axios({
    method: 'get',
    url: `${commonV3URL}/pincode/details?pincode=${pinCode}`
  });
  return dispatch => {
    dispatch({
      type: LOADER
    });
    request
      .then(response => {
        dispatch({
          type: GET_PINCODEDETAIL,
          payload: response.data
        });
      })
      .catch(error => {
        dispatch({
          type: GET_PINCODEDETAIL_ERROR,
          payload: error.response && error.response.data
        });
        dispatch({
          type: SET_ALERT,
          payload: error.response && error.response.data,
          payload1: 'error'
        });
      });
  };
}

export function getOtp(phoneNumber) {
  const request = axios({
    method: 'post',
    url: `${commonV3URL}/subscription/mobileVerification/generateOTP?phoneNumber=${phoneNumber}`
  });
  return dispatch => {
    dispatch({
      type: LOADER
    });
    request
      .then(response => {
        dispatch({
          type: GETOTP_SUCCESS,
          payload: response.data
        });
      })
      .catch(error => {
        dispatch({
          type: GETOTP_ERROR,
          payload: error.response && error.response.data
        });
        dispatch({
          type: SET_ALERT,
          payload: error.response && error.response.data,
          payload1: 'error'
        });
      });
  };
}

export function getOtpEmpty() {
  return dispatch => {
    dispatch({
      type: GETOTP_EMPTY
    });
  };
}

export function validateOtp(otp, phoneNumber) {
  if (otp) {
    const request = axios({
      method: 'post',
      url: `${commonV3URL}/subscription/mobileVerification/validateOTP?verifyOTP=${otp}&phoneNumber=${phoneNumber}`
    });
    return dispatch => {
      dispatch({
        type: LOADER
      });
      request
        .then(response => {
          dispatch({
            type: OTPVALIDATE_SUCCESS,
            payload: response.data
          });
        })
        .catch(error => {
          dispatch({
            type: OTPVALIDATE_ERROR,
            payload: error.response && error.response.data
          });
          dispatch({
            type: SET_ALERT,
            payload: error.response && error.response.data,
            payload1: 'error'
          });
        });
    };
  } else {
    return dispatch => {
      dispatch({
        type: OTPVALIDATE_ERROR,
        payload: 'OTP is required'
      });
      dispatch({
        type: SET_ALERT,
        payload: 'OTP is required',
        payload1: 'error'
      });
    };
  }
}

export function emptyOtpValidate() {
  return dispatch => {
    dispatch({
      type: OTPVALIDATE_EMPTY
    });
  };
}

export function resetOtpSuccess() {
  return dispatch => {
    dispatch({
      type: RESET_OTP_SUCCESS
    });
  };
}

export function loaderHide() {
  return dispatch => {
    dispatch({
      type: LOADER_HIDE
    });
  };
}

export function newSubscriptionAPI(
  id,
  limits,
  gstiValues,
  clientId,
  plans,
  isRecharge
) {
  const data = {
    clientId: clientId,
    planId: id || null,
    acceptZeroPayment: false,
    ...limits,
    gstInfo: {}
  };
  gstiValues &&
    Object.values(gstiValues).some(value => value?.length !== 0) &&
    (data.gstInfo = {
      gstin: gstiValues.gstin,
      address: gstiValues.address,
      city: gstiValues.city,
      state: gstiValues.state,
      pincode: gstiValues.pinCode
    });

  let requestBody = formDataToencode64Base(data);
  const url = isRecharge
    ? `${commonV3URL}/subscription/recharge`
    : `${commonV3URL}/subscription/subscribe`;
  const request = helperAxios(url, isRecharge ? 'put' : 'post', requestBody);
  return async dispatch => {
    dispatch({
      type: LOADER
    });
    request
      .then(async response => {
        if (plans.plans.find(e => parseInt(e.id) === parseInt(id))) {
          {
            plans.plans.find(e => parseInt(e.id) === parseInt(id)).shortName ===
            'PAYG'
              ? track.event('payg_success_registration', {
                  event_category: 'bsa_analytics'
                })
              : plans.plans.find(e => parseInt(e.id) === parseInt(id))
                  .shortName === 'PPU'
              ? track.event('ppu_success_registration', {
                  event_category: 'bsa_analytics'
                })
              : track.event('free_success_registration', {
                  event_category: 'bsa_analytics'
                });
          }
        }
        if (response.data.newUser && response.data.newUser.token) {
          authService.setSession(response.data.newUser.token);
          try {
            const user = await authService.loginInWithToken();
            dispatch({
              type: '@account/login-success',
              payload: {
                user
              }
            });
          } catch (error) {
            dispatch({ type: LOGIN_FAILURE });

            throw error;
          }
        }

        dispatch({
          type: REGISTER,
          payload: response.data
        });
      })
      .catch(error => {
        dispatch({
          type: REGISTER_ERROR,
          payload: error.response && error.response.data
        });
        dispatch({
          type: SET_ALERT,
          payload: error.response && error.response.data,
          payload1: 'error',
          redirect:
            error &&
            error.response &&
            error.response.data.status === 1005 &&
            '/'
        });
      });
  };
}

export function getPlanDetailsByPlanName(shortName) {
  const url = `${commonV3URL}/plan/getDetails?type=${shortName}`;
  const request = helperAxios(url, 'get');

  return dispatch => {
    request
      .then(response =>
        dispatch({
          type: PLAN_DETAILS_BY_SHORT_NAME,
          payload: response.data
        })
      )
      .catch(error => {
        dispatch({
          type: GET_PLANS_ERROR,
          payload: error.response && error.response.data
        });
        dispatch({
          type: SET_ALERT,
          payload: error.response && error.response.data,
          payload1: 'error',
          redirect: '/'
        });
      });
  };
}
